import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {Paper} from "@material-ui/core";
import SurveySelectMenu from "./SurveySelectMenu";

const styles = {
  root:{
    marginBottom: "1rem",
    border: "1px solid #ddd",
    borderRadius: "4px"
  },
};


function SurveySelectTopPanel(props) {
  const {classes, ...passProps} = props;

  return (
    <Paper className={classes.root}>
      <SurveySelectMenu {...passProps} />
    </Paper>
  );
}

export default withStyles(styles)(SurveySelectTopPanel);
